const getRequestData = (action) => action.payload.requestData.data;
const getRequestDataErrors = (action) =>
  action &&
  action.payload &&
  action.payload.requestData &&
  action.payload.requestData.errors;
const getIncludedData = (action) => action.payload.requestData.included || [];
const getInitActionPayload = (action) => action.payload.initAction.payload;
const getRequestMetaData = (action) => action.payload.requestData.meta;

const selectAllFromApiState = (state, object) =>
  state.api[object] && state.api[object].all;

export {
  getRequestData,
  getRequestDataErrors,
  getIncludedData,
  selectAllFromApiState,
  getInitActionPayload,
  getRequestMetaData,
};
